import { createAction, props } from '@ngrx/store';

export const initUserDetails = createAction('[UserDetails Page] Init');

//Action for loggedInUserProfile.
export const loggedInUserProfile = createAction('[Shared/API] loggedInUserProfile');
export const loggedInUserProfileSuccess = createAction(
  '[Shared/API] loggedInUserProfile Success',
  props<{ profileData: any }>()
);
export const loggedInUserProfileFailure = createAction(
  '[Shared/API] loggedInUserProfile Failure',
  props<{ error: any }>()
);

//Action for userProfileOverview.
export const userProfileOverview = createAction('[Shared/API] userProfileOverview');
export const userProfileOverviewSuccess = createAction(
  '[Shared/API] userProfileOverview Success',
  props<{ userProfileOverview: any }>()
);
export const userProfileOverviewFailure = createAction(
  '[Shared/API] userProfileOverview Failure',
  props<{ error: any }>()
);
export const clearUserProfileOverview = createAction('[Shared/API] userProfileOverview clear data');

//Action for saveUserPersonalInfo.
export const saveUserPersonalInfo = createAction(
  '[Shared/API] saveUserPersonalInfo',
  props<{ payload: any }>()
);
export const saveUserPersonalInfoSuccess = createAction(
  '[Shared/API] saveUserPersonalInfo Success',
  props<{ userProfileOverview: any }>()
);
export const saveUserPersonalInfoFailure = createAction(
  '[Shared/API] saveUserPersonalInfo Failure',
  props<{ error: any }>()
);

//Action for getUserPersonalInfo.
export const getUserPersonalInfo = createAction('[Shared/API] getUserPersonalInfo');
export const getUserPersonalInfoSuccess = createAction(
  '[Shared/API] getUserPersonalInfo Success',
  props<{ userPersonalInfo: any }>()
);
export const getUserPersonalInfoFailure = createAction(
  '[Shared/API] getUserPersonalInfo Failure',
  props<{ error: any }>()
);

//Action for getUserProfileImage.
export const getUserProfileImage = createAction('[Shared/API] getUserProfileImage');
export const getUserProfileImageSuccess = createAction(
  '[Shared/API] getUserProfileImage Success',
  props<{ userProfileImageData: any }>()
);
export const getUserProfileImageFailure = createAction(
  '[Shared/API] getUserProfileImage Failure',
  props<{ error: any }>()
);

//Action for updateUserProfileImage.
export const updateUserProfileImage = createAction(
  '[Shared/API] updateUserProfileImage',
  props<{ payload: any }>()
);
export const updateUserProfileImageSuccess = createAction(
  '[Shared/API] updateUserProfileImage Success',
  props<{ userProfileImageData: any; userImageStatus: boolean }>()
);
export const updateUserProfileImageFailure = createAction(
  '[Shared/API] updateUserProfileImage Failure',
  props<{ error: any }>()
);
export const clearUserProfileImage = createAction('[Shared/API] clear user profile image data');

//Action for getUserEmailPreferences.
export const getUserEmailPreferences = createAction('[Shared/API] getUserEmailPreferences');
export const getUserEmailPreferencesSuccess = createAction(
  '[Shared/API] getUserEmailPreferences Success',
  props<{ userEmailPreferencesStatus: any }>()
);
export const getUserEmailPreferencesFailure = createAction(
  '[Shared/API] getUserEmailPreferences Failure',
  props<{ error: any }>()
);

//Action for updateUserEmailPreferences.
export const updateUserEmailPreferences = createAction(
  '[Shared/API] updateUserEmailPreferences',
  props<{ payload: any }>()
);
export const updateUserEmailPreferencesSuccess = createAction(
  '[Shared/API] updateUserEmailPreferences Success',
  props<{ userEmailPreferencesStatus: any }>()
);
export const updateUserEmailPreferencesFailure = createAction(
  '[Shared/API] updateUserEmailPreferences Failure',
  props<{ error: any }>()
);

//Action for getOrganization.
export const getOrganization = createAction('[Shared/API] getOrganization');
export const getOrganizationSuccess = createAction(
  '[Shared/API] getOrganizationSuccess Success',
  props<{ organizationList: any; selectedOrg: any }>()
);
export const getOrganizationFailure = createAction(
  '[Shared/API] getOrganizationFailure Failure',
  props<{ error: any }>()
);

//Action for changeOrganization.
export const changeOrganization = createAction(
  '[Shared/API] changeOrganization',
  props<{ payload: any }>()
);
export const changeOrganizationSuccess = createAction(
  '[Shared/API] changeOrganization Success',
  props<{ organizationData: any }>()
);
export const changeOrganizationFailure = createAction(
  '[Shared/API] changeOrganization Failure',
  props<{ error: any }>()
);

export const regenerateAccessToken = createAction(
  '[Shared/API] regenerateAccessToken',
  props<{ sessionString?: string }>()
);
export const regenerateAccessTokenSuccess = createAction(
  '[Shared/API] regenerateAccessToken Success',
  props<{ tokenClaim: any; organizationName: any; showToast: boolean }>()
);
export const regenerateAccessTokenFailure = createAction(
  '[Shared/API] regenerateAccessToken Failure',
  props<{ error: any }>()
);

export const clearStateOfUserDetaills = createAction('[Shared/API] Clear Email Validation');
